<template>
  <div class="audio">
    <div class="audio--wrap" @click="play">
      <audio :src="audio.src" ref="audio"></audio>
      <div class="audio--center">
        <i class="play" :class="{ palying: audio.playing }"></i>
        <span class="countdown">{{ audio.currentTime }}<sup>〃</sup></span>
        <!-- <span class="countdown" v-else>{{audio.length}}<sup>〃</sup></span> -->
      </div>
      <span class="load" v-show="waiting"></span>
    </div>
  </div>
</template>

<script>
import fetch from '@/plugins/fetch'

/*eslint-disable*/
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {
                    src: '',
                    progress: 0,
                    title: '',
                    currentTime: 0,
                    duration: 0,
                    state: false
                }
            }
        },
        id: {
            type: Number
        }
    },
    filters: {
        countDown(ms) {
            if (ms > 0) {
                const secondnum = Math.floor(ms / 1000, 0)
                return secondnum
            }
            return 0
        }
    },
    data() {
        return {
            waiting: false,
            interval: null,
            onlineInterval: null,
            listened: false,
            audio: {
                ...{
                    src: '',
                    currentTime: 0,
                    playing: false,
                    length: 0,
                },
                ...this.item,
                ...{
                    length: Math.floor(this.item.length / 1000)
                }
            },
        }
    },
    mounted() {
        const el = this.$refs.audio
        this.audio.currentTime = this.audio.currentTime ? this.audio.currentTime : this.audio.length
        el.addEventListener('playing', () => {
            this.waiting = false
            this.interval = setInterval(() => {
                --this.audio.currentTime // eslint-disable-line
                this.audio.playing = true
                if (this.audio.currentTime < 0) {
                    this.stop()
                    // this.$refs.audio.load()
                    this.audio.currentTime = this.audio.length
                    // this.audio.playing = false
                }
            }, 1000)
        })
        window.addEventListener('online', () => {
            this.waiting = false
        }, false)
        el.addEventListener('waiting', () => {
            this.waiting = true
        })
        el.addEventListener('error', () => {
            console.log('error')
            this.waiting = true
        })
        el.addEventListener('onended', () => {
            this.waiting = false
        })
    },
    destory() {
        // clearInterval(this.onlineInterval);
        clearInterval(this.interval)
    },
    methods: {
        play($event) {
            $event.preventDefault();
            $event.stopPropagation();
            const el = this.$refs.audio
            if (el.paused) {
                if (!navigator.onLine) {
                    this.waiting = true
                    // clearInterval(this.onlineInterval)
                    // this.onlineInterval = setInterval(() => {
                    //     if (navigator.onLine) {
                    //         this.tick()
                    //     } else {
                    //         [...document.querySelectorAll('audio')].forEach((audio) => {
                    //             if (!audio.paused && audio !== this.$refs.audio) {
                    //                 audio.click()
                    //             }
                    //         })
                    //     }
                    // }, 2000)
                    return false
                }
                this.tick()
            } else {
                this.stop()
            }
        },
        tick($event) {
            clearInterval(this.onlineInterval);
            [...document.querySelectorAll('audio')].forEach((audio) => {
                if (!audio.paused && audio !== this.$refs.audio) {
                    audio.click()
                }
            })
            const el = this.$refs.audio
            el.play()
            if (!this.listened) {
                const answer_id = this.id
                const uid = this.$$cookie('uid')
                fetch(`${this.$$hostname('ask')}/api/v1/answers/addListen`,{answer_id:answer_id,uid:uid},{ method: 'POST' })
                .catch((err) => {

                }).then(() => {
                    this.listened = true
                })
            }
        },
        stop($event) {
            const el = this.$refs.audio
            el.pause()
            this.audio.playing = false
            clearInterval(this.interval)
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.audio {
    display: flex;
    align-items: center;
    font-size: rem(26px);
    &--wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: rem(20px);
        background: url(../../assets/images/audio.png) left center no-repeat;
        background-size: contain;
        width: rem(420px);
    }
    &--center {
        display: flex;
        align-items: center;
    }
    &--listened {
        padding-left: rem(20px);
        color: #999;
    }
    .play {
        display: inline-block;
        width: rem(42px);
        height: rem(40px);
        margin-right: rem(20px);
        margin-left: rem(10px);
        background-image: url(../../assets/images/icon_audio_3.png);
        background-repeat: no-repeat;
        background-size: contain;
        &.palying {
            animation: audio_playing 1.5s infinite;
        }
    }
    .title {
        margin-left: rem(20px);
        display: inline-block;
        width: rem(400px);
        font-size: rem(30px);
        color: #121212;
        line-height: rem(50px);
        white-space: nowrap;
        overflow: auto;
    }
    .countdown {
        font-size: rem(26px);
        color: #999;
    }
    // .progress {
    //     position: absolute;
    //     left: 0;
    //     bottom: 0;
    //     background-color: #0cbb08;
    //     height: rem(4);
    // }
    .load {
        width: rem(30px);
        height: rem(30px);
        background: url(../../assets/images/load@3x.png) 0 0 no-repeat;
        background-size: cover;
        animation: rotate 2s linear infinite;
    }
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes audio_playing {
    33% {
        background-image: url(../../assets/images/icon_audio_1.png)
    }

    66% {
        background-image: url(../../assets/images/icon_audio_2.png)
    }

    100% {
        background-image: url(../../assets/images/icon_audio_3.png)
    }
}
</style>
